import React, {useEffect, useState} from 'react';
import './scss/transactions.scss';
import Api from '../services/api';
import PaginationNova from "./pagination-nova";
import Layout from "./layout";
import crypto from "crypto";
import FullScreenLoader from "./full-screen";

function TransactionList(): React.ReactElement {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(10);
    const [itemCount, setItemCount] = useState(10);
    const [resetPaging, setResetPaging] = useState(false);
    const [transactions, setTransactions] = useState([]);
    let tx: any = {}
    const [headerTmpTx, setHeaderTmpTx] = useState(tx);
    const [isLoading, setIsLoading] = useState(true);


    const handlePageClick = (pageSize: number, pageNumber: number) => {
        setCurrentPage(pageNumber);
        setPageCount(pageSize);
    };

    useEffect(() => {
        setIsLoading(true);
        Api.getTransactions(
            pageCount + 1,
            (currentPage - 1) * pageCount,
        ).then(txs => {
            setItemCount(txs.length / 2);
            // Store unique transaction hashes
            const txHashList = [...new Set(txs.map((item: any) => item.parentHash))];
            let groupedTransfers: any[] = [];
            txHashList.forEach((parentHash) => {
                const events = txs.filter((e: any) => e.parentHash === parentHash);
                const fEvent = events[0];
                let tx = {
                    txId: fEvent.parentHash,
                    blockchain: fEvent.blockchain,
                    contract: {
                        address: fEvent.contract.address,
                        standard: fEvent.contract.standard,
                    },
                    timestamp: fEvent.timestamp,
                    legacy: fEvent.legacy,
                    blockHeight: fEvent.blockHeight,
                    transfers: [],
                    multiple: false
                }
                let transferMap: Map<string, any> = new Map<string, any>();
                if (events?.length > 1) {
                    console.log(parentHash);
                    tx.multiple = true;
                    events.forEach((e: any) => {
                        let s = e.source;
                        let d = e.destination;
                        let k = crypto.createHash('md5').update(s + d).digest("hex");
                        let mk = transferMap.get(k);
                        if (mk) {
                            mk.tokens.push({token: e.contract.token.tokenId, value: e.quantity, orbs: e.orbs});
                        } else {
                            transferMap.set(k, {
                                source: s,
                                destination: d,
                                tokens: [{token: e.contract.token.tokenId, value: e.quantity, orbs: e.orbs}]
                            });
                        }
                    });
                    transferMap.forEach((v, k) => {
                        (tx.transfers as any[]).push(v);
                    })

                } else {
                    (tx.transfers as any[]).push({
                        source: fEvent.source,
                        destination: fEvent.destination,
                        tokens: [{token: fEvent.contract.token.tokenId, value: fEvent.quantity, orbs: fEvent.orbs}]
                    });
                }
                groupedTransfers.push(tx);

            });

            if (groupedTransfers?.length > 0)
                setHeaderTmpTx(groupedTransfers[0] as any);
            setTransactions(groupedTransfers as any);

            setIsLoading(false);

        }).catch(reason => {
            setIsLoading(false);
            console.log(reason)
        });
    }, [currentPage, pageCount]);

    return (
        <Layout className="page transactions">
            <div className="pt-3 loading-wrapper">
                {isLoading ? <FullScreenLoader/> : ''}
                <div className="accordion" id="accordionHeader">
                    <div className="accordion-item">
                        <h2 className="accordion-header" id={"headingOne"}>
                            <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target={"#collapseOne"} aria-expanded="true"
                                    aria-controls={"collapseOne"} style={{backgroundColor: "#ffd6d6"}}>
                                <table className="table item">
                                    <thead className={"header"}>
                                    <tr style={{visibility: "hidden", height: "1px"}}>
                                        <td scope="row" className={"item-a address"}
                                            style={{border: "0px solid"}}>{headerTmpTx?.txId}</td>
                                        <td style={{border: "0"}} className={"item-c"}>{headerTmpTx?.blockchain}</td>
                                        <td className={" item-a address"}
                                            style={{border: "0"}}>{headerTmpTx?.contract?.address}</td>
                                        <td style={{border: "0"}} className={"item-c"}>{headerTmpTx?.timestamp}</td>
                                        <td style={{border: "0"}}
                                            className={"item-c"}>{headerTmpTx?.blockHeight}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row" className={"item-a address"}
                                            style={{border: "0px solid"}}>Transaction
                                            Hash
                                        </th>
                                        <th style={{border: "0"}} className={"item-c"}>Blockchain</th>
                                        <th className={" item-a address"} style={{border: "0"}}>Contract
                                        </th>
                                        <th style={{border: "0"}} className={"item-c"}>Timestamp</th>
                                        <th style={{border: "0"}} className={"item-c"}>Block</th>
                                    </tr>
                                    </thead>
                                </table>
                            </button>
                        </h2>
                    </div>
                </div>
                <div className="accordion" id="accordionTx">
                    {
                        transactions?.map((superTx: any, index) => (
                            <div className="accordion-item">
                                <h2 className="accordion-header" id={"headingOne" + index}>
                                    <button className={"accordion-button" + (superTx.multiple ? " multiple" : "")}
                                            type="button" data-bs-toggle="collapse"
                                            data-bs-target={"#collapseOne" + index} aria-expanded="true"
                                            aria-controls={"collapseOne" + index}>
                                        <table className="table item">
                                            <tbody>
                                            <tr>
                                                <td scope="row" className={"item-a address"}
                                                    style={{border: "0px solid"}}><a style={{zIndex:"999999"}} target="_blank" href={"/transaction/" + superTx.txId}>{superTx.txId}</a></td>
                                                <td style={{border: "0"}} className={"item-c"}>{superTx.blockchain}</td>
                                                <td className={" item-a address"}
                                                    style={{border: "0"}}>{superTx.contract?.address}</td>
                                                <td style={{border: "0"}} className={"item-c"}>{superTx.timestamp}</td>
                                                <td style={{border: "0"}}
                                                    className={"item-c"}>{superTx.blockHeight}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </button>
                                </h2>
                                <div id={"collapseOne" + index} className="accordion-collapse collapse"
                                     aria-labelledby={"headingOne" + index}
                                     data-bs-parent="#accordionTx" style={{backgroundColor: "#ffe9ed"}}>
                                    <div className="accordion-body">
                                        <table className="table">
                                            <thead>
                                            <tr>
                                                <th className={"title normal-text-italic"} colSpan={4} scope="col"
                                                    style={{fontSize: ".9rem"}}>Transfers
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                superTx.transfers?.map((transfer: any) => (
                                                    <tr>
                                                        <td>
                                                            <table className="table">
                                                                <tbody>
                                                                <tr>
                                                                    <td><span style={{
                                                                        overflow: "hidden",
                                                                        display: "inline-block"
                                                                    }}>Tokens transferred</span><span style={{
                                                                        padding: "0 10px",
                                                                        overflow: "hidden",
                                                                        display: "inline-block"
                                                                    }}> From </span><span className={"address"}><a
                                                                        style={{color: "blue"}}
                                                                        title={transfer.source}
                                                                        href={"/transactions"}>{transfer.source}</a></span><span
                                                                        style={{
                                                                            padding: "0 10px",
                                                                            overflow: "hidden",
                                                                            display: "inline-block"
                                                                        }}>To</span><span title={transfer.destination}
                                                                                          className={"address"}><a
                                                                        style={{color: "blue"}}
                                                                        href={"/transactions"}>{transfer.destination}</a></span>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <table className="table">
                                                                            <tbody>
                                                                            {transfer.tokens?.map((token: any) => (
                                                                                <tr>
                                                                                    <td className="normal-text-italic"
                                                                                        style={{fontSize: ".9rem"}}>
                                                                                        <span className={"arrow"}
                                                                                              style={{marginLeft: "0rem"}}>{token.value}</span>
                                                                                        <span style={{padding: "5px"}}>of Token ID</span><span>{token.token}</span>
                                                                                        {token.orbs?.map((orb: any) => (
                                                                                            <span>
                                                                                                <span style={{paddingLeft: "10px"}}>|</span>
                                                                                            <a target="_blank"
                                                                                               href={orb.imgURL}
                                                                                               style={{padding: "0 10px"}}
                                                                                               className="rounded">
                                                                                                <img alt="ORB"
                                                                                                     src={orb.imgURL}
                                                                                                     style={{
                                                                                                         width: "20px",
                                                                                                         height: "20px"
                                                                                                     }}
                                                                                                     className="rounded-circle image-fill-smaller"/>
                                                                                            </a>
                                                                                            <span>
                                                                                                <a href={"/collection?id=" + orb.collection?.id}>{orb.collection?.name}</a>
                                                                                            </span>
                                                                                            </span>
                                                                                        ))}
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div>
                <PaginationNova itemCount={itemCount} onPageClick={handlePageClick} reset={resetPaging}/>
            </div>
            <div/>
        </Layout>
    );
}

export default TransactionList;
